/*
 * dashboard (page)
 */
import { Container, PageHeader, Page } from "@psychology/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import {
	Bot,
	Clipboard,
	// Calendar,
	HeartPlus,
	PocketKnife,
	ScrollText,
	User,
	Users,
} from "lucide-react"
import { DashboardCard } from "../components/dashboard-card"
import { authPageLoader } from "../utils/auth.utils"

export const Route = createFileRoute("/dashboard")({
	component: DashboardPage,
	loader: authPageLoader,
})

function DashboardPage() {
	return (
		<Page>
			<Container width={"xxxl"} padding={"lg"} gap={"lg"}>
				<PageHeader title={"Psychology Dashboard"} />

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					<DashboardCard
						title="Journal"
						description="Your private space to journal thoughts and feelings. Our AI gently analyzes your entries over time to help you uncover patterns, triggers, and insights for deeper self-awareness."
						to="/journal"
						icon={<ScrollText className="w-8 h-8" />}
						gradient="from-emerald-500 to-emerald-300"
					/>
					<DashboardCard
						title="Therapy Session"
						description="Keep track of reminders to mention during your next therapy session."
						to="/therapy/session"
						icon={<Clipboard className="w-8 h-8" />}
						gradient="from-emerald-500 to-emerald-300"
					/>
					<DashboardCard
						title="People"
						description="Track important people in your life and their relationships with you. AI helps identify mentioned individuals and understand relationship dynamics for better social insights."
						to="/people"
						icon={<Users className="w-8 h-8" />}
						gradient="from-teal-500 to-teal-300"
					/>
					<DashboardCard
						title="AI Chat"
						description="Need to talk? Our AI Chat offers a supportive, non-judgmental space 24/7. Explore feelings, discuss challenges, and learn coping techniques with empathetic guidance."
						to="/chat"
						icon={<Bot className="w-8 h-8" />}
						gradient="from-blue-500 to-blue-300"
					/>
					<DashboardCard
						title="Quizzes"
						description="Log results from standard mental health assessments (like PHQ-9, GAD-7) or take our guided quizzes. Our AI helps visualize trends and provides insights into your journey."
						to="/quiz"
						icon={<PocketKnife className="w-8 h-8" />}
						gradient="from-purple-500 to-purple-300"
					/>
					<DashboardCard
						title="My Emergency Plan"
						description="Manage your emergency contacts and access crisis resources. Create a safety plan with people you can reach out to during difficult times."
						to="/emergency/plan"
						icon={<HeartPlus className="w-8 h-8" />}
						gradient="from-red-500 to-red-300"
					/>
					{/* <DashboardCard
						title="Routines"
						description="Establish and track routines that support your well-being (e.g., meditation, exercise, gratitude). Get AI-powered suggestions tailored to your goals."
						to="/routine"
						icon={<Calendar className="w-8 h-8" />}
						gradient="from-orange-500 to-orange-300"
					/> */}
					<DashboardCard
						title="User Details"
						description="Share optional background details here. This helps our AI understand your unique context for more relevant insights and tailored support across all features."
						to="/user-details"
						icon={<User className="w-8 h-8" />}
						gradient="from-slate-500 to-slate-300"
					/>
				</div>
			</Container>
		</Page>
	)
}
